module.exports = "\n\n<a *ngIf=\"kit?.id\" class=\"link-edit w-inline-block\" [routerLink]=\"['kit-update', kit?.id]\">\n  <img src=\"/assets/images/edit.svg\" width=\"20\">\n</a>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/kit/kit.component.html
// module id = 1011
// module chunks = 1